var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGift = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6667 13.3333H30.7667C31.3542 12.3205 31.6646 11.1709 31.6667 10C31.6667 7.23858 29.4281 5 26.6667 5C23.9621 5.33105 21.532 6.81339 20 9.06667C18.468 6.81339 16.0379 5.33105 13.3333 5C10.5719 5 8.33333 7.23858 8.33333 10C8.33541 11.1709 8.64582 12.3205 9.23333 13.3333H8.33333C6.49238 13.3333 5 14.8257 5 16.6667V21.6667C5 22.5871 5.74619 23.3333 6.66667 23.3333H8.33333V31.6667C8.33333 33.5076 9.82572 35 11.6667 35H28.3333C30.1743 35 31.6667 33.5076 31.6667 31.6667V23.3333H33.3333C34.2538 23.3333 35 22.5871 35 21.6667V16.6667C35 14.8257 33.5076 13.3333 31.6667 13.3333ZM26.6667 8.33333C27.5871 8.33333 28.3333 9.07952 28.3333 10C28.335 11.1088 27.7853 12.1458 26.8667 12.7667C26.3149 13.1375 25.6648 13.3348 25 13.3333H21.6667C21.6667 11.5167 24.85 8.33333 26.6667 8.33333ZM13.3333 8.33333C12.4129 8.33333 11.6667 9.07952 11.6667 10C11.6667 11.8409 13.159 13.3333 15 13.3333H18.3333C18.3333 11.5167 15.15 8.33333 13.3333 8.33333ZM8.33333 16.6667H18.3333V20H8.33333V16.6667ZM18.3333 31.6667V23.3333H11.6667V31.6667H18.3333ZM21.6667 31.6667V23.3333H28.3333V31.6667H21.6667ZM21.6667 16.6667V20H31.6667V16.6667H21.6667Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGift, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gift.b188e5ab.svg";
export { ForwardRef as ReactComponent };